import './Hero.css'

export function Hero({ homeRef }) {

    return (
        <div ref={homeRef} className="hero">
            <section>
                <div className="left">
                    <h1>  So, you want to travel to <strong>Space</strong>
                    </h1>
                    <p>Let’s face it; if you want to go to space, you might as well genuinely go to
                        outer space and not hover kind of on the edge of it. Well sit back, and relax
                        because we’ll give you a truly out of this world experience!
                    </p>
                </div>
                <div className="right">
                    <a href="https://explore.com">Explore</a>
                </div>
            </section>
        </div>
    )
}  